import { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Lazy load components for code splitting
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    // Set page title
    document.title = 'Alumni Management System';

    // Remove any Emergent badge that might exist
    const emergentBadge = document.getElementById('emergent-badge');
    if (emergentBadge) {
      emergentBadge.remove();
    }

    // Also check for any elements with emergent-related classes or IDs
    try {
      const emergentElements = document.querySelectorAll('[id*="emergent"], [id*="Emergent"], [class*="emergent"], [class*="Emergent"]');
      emergentElements.forEach(el => {
        try {
          if (el && el.remove) {
            el.remove();
          }
        } catch (e) {
          // Skip if error removing element
        }
      });
    } catch (e) {
      // Silently fail
    }
  }, []);

  const handleLogin = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2D3436] mx-auto mb-4"></div>
              <p className="text-gray-600">Memuat...</p>
            </div>
          </div>
        }>
          <Routes>
            <Route
              path="/login"
              element={!token ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
            />
            <Route
              path="/"
              element={token ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;